// components/YoutubePlaylist.js
import React from 'react';
import styles from "../../pages/upsc-prestorming-prelims-test-series/prestorming.module.css";


const YoutubePlaylist = ({ playlist }) => {
    console.log(playlist);
    if (!playlist ) {
        return <p>No playlist found.</p>; // Handle the case when playlist is undefined
      }
  return (
    <div className={`${styles.iframe} `}>

      <div className= 'd-none d-md-block'>
          <iframe 
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${playlist.snippet.resourceId.videoId}`}
            
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
      </div>

      <div className= 'd-block d-md-none'>
          <iframe 
            width="400"
            height="300"
            src={`https://www.youtube.com/embed/${playlist.snippet.resourceId.videoId}`}
            
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
      </div>

  </div>

  

  

  


  
  );
};




export default YoutubePlaylist;
